module.exports = __webpack_public_path__ + "static/img/quick-icon-d.ac97ed9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/quick-icon-d.png
// module id = 1IGC
// module chunks = 3 5